<!-- 执教经验 -->
<template>
  <div id="coaching" >
    <van-cell-group class="group">
      <van-field
        clearable
        v-model="info.exHirers"
        label="退役后供职单位/公司"
        placeholder="多个单位以', '分隔"
        class="label-win"
        input-align="right"
      >
      </van-field>
      <van-field
        clearable
        v-model="info.exCoachTeams"
        label="曾经带队名称"
        placeholder="多个球队以', '分隔"
        class="label-win"
        input-align="right"
      >
      </van-field>
    </van-cell-group>

    <!--<van-cell-group class="group" @click="show = true" >-->
      <!--<van-field-->
        <!--clearable-->
        <!--readonly-->
        <!--v-model="info.certificateLevel"-->
        <!--label="现所持资格书等级"-->
        <!--placeholder="请选择"-->
        <!--class="label-win"-->
        <!--input-align="right"-->
      <!--&gt;</van-field>-->
    <!--</van-cell-group>-->

    <van-cell-group class="group">
      <van-field
        clearable
        v-model="info.certificateLevel"
        label="所持资格证证书"
        placeholder="资格证证书"
        class="label-win"
        input-align="right"
      >
      </van-field>
    </van-cell-group>

    <van-cell-group class="group">
      <van-field
        clearable
        v-model="info.certificateIssuedBy"
        label="发证单位"
        placeholder="发证单位"
        class="label-win"
        input-align="right"
      >
      </van-field>
    </van-cell-group>
    <div class="textarea" >
      <h5>取得成绩</h5>
      <textarea v-model="info.coachingPerformance" placeholder="请输入文字内容..." name="" id="" cols="30" rows="4"></textarea>
    </div>
    <!-- 场上位置 -->
    <van-popup v-model="show" position="bottom" :overlay="true">
      <van-picker show-toolbar :columns="columns" @cancel="onCancel" @confirm="onConfirm" ></van-picker>
    </van-popup>

    <van-button class="btn" v-if="!isRead || isAppend" size="large" @click="routerPush()" >下一步</van-button>
    <van-button class="btn" v-if="isRead && !isAppend" size="large" @click="updateCoach()" >保存</van-button>
  </div>
</template>
<script>
import Vue from 'vue'
import { getValidMembership } from '@/utils'
import Validator from '@/libs/validator'
import { setRegisterInfo, getRegisterInfo, getMemberType } from '@/libs/cookie-storage'
import { getMyCoach, updateCoach } from '@/api/info'

import { Field, Popup, Picker, Button, Toast } from 'vant'

Vue.use(Field).use(Picker).use(Popup).use(Button)

export default {
  name: 'Experience',
  data() {
    return {
      columns: ['高级', '中级', '普通'],
      show: false,
      info: {
        exHirers: null,
        exCoachTeams: null,
        certificateLevel: null,
        certificateIssuedBy: null,
        coachingPerformance: null
      },
      isRead: false,
      isAppend: false,
      reset: ''
    }
  },
  created() {
    const memberType = getMemberType()
    if (!memberType) return
    this.type = memberType.type
    const regInfo = getRegisterInfo()
    if (regInfo) {
      this.info = Object.assign(this.info, regInfo)
    }
    if (memberType.status === 2) {
      this.isRead = true
      this.getMyCoach()
    }
    this.validator = new Validator({
      data: this.info
    })
    this.reset = this.$route.query.reset
    this.validMemberShip = getValidMembership()
    if(this.validMemberShip.membership && this.validMemberShip.membership.length > 0) {
      const obj = _.find(this.validMemberShip.membership, function (item) {
        return item.membershipTypeId === memberType.membershipTypeId
      })
      this.isAppend = !obj
      if (this.isAppend) {
        this.isRead = true
      }
    }
  },
  mounted() {},
  computed: {},
  methods: {
    routerPush() {
      const regInfo = Object.assign(getRegisterInfo(), this.info)
      setRegisterInfo(regInfo)
      this.$router.push('contact-information')
    },
    onCancel() {
      this.show = false
    },
    onConfirm(value) {
      this.show = false
      this.info.certificateLevel = value
    },
    getMyCoach() {
      getMyCoach().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.coach.user, data.coach)
        }
      })
    },
    updateCoach() {
      const params = {
        id: this.info.id,
        exHirers: this.info.exHirers,
        exCoachTeams: this.info.exCoachTeams,
        certificateLevel: this.info.certificateLevel,
        certificateIssuedBy: this.info.certificateIssuedBy
      }
      updateCoach(params).then(response => {
        const data = response.data
        if (data) {
          Toast('保存成功')
          if (this.reset==1) {
            this.$router.push({path: 'contact-information', query: {reset: 1}})
          } else {
            this.$router.push('ucenter')
          }
        }
      })
    },
  }
}
</script>
<style>

  #coaching {
    height: 100%;
    background-color: white;
  }

  #coaching .title {
    padding: 15px 15px;
    width: calc(100% - 30px);
    background-color: #bfcdd9;
    margin-top: 30px;
  }

  #coaching .label-win {
    font-size: 16px;
  }

  #coaching .label-win .van-cell__title {
    max-width: 110px;
  }

  #coaching .textarea {
    padding: 15px;
    width: calc(100% - 30px);
  }

  #coaching .textarea h5 {
    font-size: 16px;
    padding-bottom: 10px;
  }

  #coaching .textarea textarea {
    border: 1px solid grey;
    width: calc(100% - 20px);
    border-radius: 10px;
    padding: 10px;
    font-size: 16px;
  }

  #coaching .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  #coaching .van-hairline--top-bottom::after {
    border-width: 0;
  }

  #coaching .van-cell {
    font-size: 16px;
    padding: 20px 15px;
    border-bottom: 1px solid #F2F2F2;
  }

  #coaching .btn {
    height:60px;
    background: #185494;
    border-radius:2px;
    border: none;
    margin-top: 160px;
    font-weight:400;
    color: white;
    font-size:20px;
  }

  #coaching .textarea h5 {
    margin: 0;
    font-size:16px;
    font-weight:400;
    color: #323233;
  }

  #coaching .textarea textarea {
    border: none;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/coaching-experience.vue